import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetTitleRankingQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	filter?: Types.InputMaybe<Types.StreamingChartsFilter>;
}>;

export type GetTitleRankingQuery = {
	__typename?: 'Query';
	streamingCharts: {
		__typename?: 'StreamingChartsConnection';
		edges?: Array<{
			__typename?: 'StreamingChartsTitlesEdge';
			streamingChartInfo?: {
				__typename?: 'StreamingChartInfo';
				rank: number;
				trend: Types.ModuleContentTitleTrend;
				trendDifference: number;
			} | null;
		}> | null;
	};
};

export const GetTitleRankingDocument = gql`
	query GetTitleRanking($country: Country!, $filter: StreamingChartsFilter) {
		streamingCharts(country: $country, filter: $filter) {
			edges {
				streamingChartInfo {
					rank
					trend
					trendDifference
				}
			}
		}
	}
`;
